import React from 'react'
import { ReactComponent as CloseXIcon } from 'ui-components/src/images/monochrome-icons/x-icon.svg';
import './ContactUsDialog.scss';

const ContactUsDialog = ({ closeDialog, email = 'saas.support@netapp.com' , text = 'For any questions, contact us at', noChat}) => {
    const mailTo = `mailto:${email}`;
    const openIntercom = () => window.Intercom('show');
    return <div>
        <header>
            Contact Us
            <button onClick={closeDialog}><CloseXIcon/></button>
        </header>
        <div className='dialog-content'>
            <p>{text} <a href={mailTo}>{email}</a> {!noChat && <span>or start a <span className='dialog-link' onClick={openIntercom}>chat</span> with us.</span>}</p>
        </div>
        <div className="button-row">
            <button className="dialog-button" onClick={closeDialog}>OK</button>
        </div>
    </div>
};

export { ContactUsDialog }